import { decodeBase64Utf8 } from "./base64";

const DEFAULT_EXPIRY_SKEW_MS = 30_000;

export function decodeJwtPayload(jwtToken: string): Record<string, unknown> | null {
  const [, payloadB64] = jwtToken.split(".");
  if (!payloadB64) {
    return null;
  }

  try {
    const base64 = payloadB64.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(decodeBase64Utf8(padded)) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function isJwtExpired(jwtToken: string, expirySkewMs: number = DEFAULT_EXPIRY_SKEW_MS): boolean {
  const payload = decodeJwtPayload(jwtToken);
  const exp = payload?.exp;
  if (typeof exp !== "number") {
    return false;
  }

  return Date.now() >= exp * 1000 - expirySkewMs;
}

export function getEmailFromJwt(jwtToken: string): string | null {
  const payload = decodeJwtPayload(jwtToken);
  const email = payload?.email;
  if (typeof email !== "string" || email.length === 0) {
    return null;
  }
  return email.toLowerCase();
}
